import React, { useContext } from 'react';
import { Button, makeStyles } from '@material-ui/core';
import AddCircleOutlineOutlinedIcon from '@material-ui/icons/AddCircleOutlineOutlined';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { drawerWidthClosed, drawerWidthOpened } from 'components/Menu/Menu';
import { MenuContext } from 'menuContext';

const useStyles = makeStyles({
  bottomButtonBar: {
    display: 'flex',
    justifyContent: 'center',
    position: 'fixed',
    bottom: 20,
    left: drawerWidthClosed,
    right: 0,
    backgroundColor: 'white',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    paddingBottom: '10px',
    paddingTop: '15px',
    zIndex: 100,

    '& > *': {
      margin: '0 10px',
    },
  },
  openMenuButtonBar: {
    left: drawerWidthOpened,
  },
});

type BottomButtonBarProps = {
  disablePrevious?: boolean;
  formName: string;
  previousStepLabel: string;
  previousStepIcon?: React.ReactNode;
  previousButtonLink?: string;
  onClickPrevious?: () => void;
  nextStepLabel: string;
  nextStepIcon?: React.ReactNode;
  nextColor?: 'default' | 'primary';
  disableNext?: boolean;
  onClickNext?: () => void;
  hideBackButton?: boolean;
};

const BottomButtonBar: React.FC<BottomButtonBarProps> = ({
  disablePrevious,
  disableNext,
  onClickPrevious,
  formName,
  nextStepLabel,
  nextStepIcon,
  nextColor,
  previousStepLabel,
  previousStepIcon,
  previousButtonLink,
  hideBackButton = false,
  onClickNext,
}) => {
  const { open } = useContext(MenuContext);
  const classes = useStyles({ openMenu: open });

  const additionalPreviousButtonProps = Boolean(previousButtonLink)
    ? {
        component: Link,
        to: previousButtonLink,
      }
    : { onClick: onClickPrevious };

  return (
    <div className={classNames(classes.bottomButtonBar, { [classes.openMenuButtonBar]: open })}>
      {!hideBackButton && (
        <Button
          disabled={disablePrevious}
          startIcon={previousStepIcon || <CancelOutlinedIcon />}
          variant="outlined"
          {...additionalPreviousButtonProps}
        >
          {previousStepLabel}
        </Button>
      )}
      <Button
        disabled={disableNext}
        endIcon={nextStepIcon || <AddCircleOutlineOutlinedIcon />}
        variant="outlined"
        color={nextColor ?? 'primary'}
        onClick={onClickNext}
        type="submit"
        form={formName}
      >
        {nextStepLabel}
      </Button>
    </div>
  );
};

export default BottomButtonBar;
